import { TColumn } from '../../../columns/column.model';
import { ESortOrder } from '../../../sort-order-enum';

export function getTitleClassName(column: TColumn, ...modifiers: string[]): string {
  const baseClass = 'site-table__sum__title';
  const classes = [baseClass, ...modifiers.map((m) => `${baseClass}--${m}`)];

  if (column?.sortOrder) {
    const direction = column.sortOrder === ESortOrder.ASC ? 'asc' : 'desc';
    classes.push(`${baseClass}--sorted-${direction}`);
  }

  return classes.join(' ');
}
